import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import logo from "../../assest/logo-2.png.png";
import Arrow from "../../assest/arrow.png";
import "./Header.css";

// NavDropdown Component
const NavDropdown = ({ t, language, isMobile, handleNavClick }) => {
  const [servicesOpen, setServicesOpen] = useState(false);
  const [generalContractingOpen, setGeneralContractingOpen] = useState(false);
  const [equipmentRentalOpen, setEquipmentRentalOpen] = useState(false);
  const [manpowerSupplyOpen, setManpowerSupplyOpen] = useState(false);
  const [transportationServicesOpen, setTransportationServicesOpen] = useState(false);

  const toggleServices = (e) => {
    e.stopPropagation();
    setServicesOpen(!servicesOpen);
    if (!servicesOpen) {
      setGeneralContractingOpen(false);
      setEquipmentRentalOpen(false);
      setManpowerSupplyOpen(false);
      setTransportationServicesOpen(false);
    }
  };

  const toggleGeneralContracting = (e) => {
    if (isMobile) {
      e.stopPropagation();
      setGeneralContractingOpen(!generalContractingOpen);
    }
  };

  const toggleEquipmentRental = (e) => {
    if (isMobile) {
      e.stopPropagation();
      setEquipmentRentalOpen(!equipmentRentalOpen);
    }
  };

  const toggleManpowerSupply = (e) => {
    if (isMobile) {
      e.stopPropagation();
      setManpowerSupplyOpen(!manpowerSupplyOpen);
    }
  };

  const toggleTransportationServices = (e) => {
    if (isMobile) {
      e.stopPropagation();
      setTransportationServicesOpen(!transportationServicesOpen);
    }
  };

  const closeAllDropdowns = () => {
    setServicesOpen(false);
    setGeneralContractingOpen(false);
    setEquipmentRentalOpen(false);
    setManpowerSupplyOpen(false);
    setTransportationServicesOpen(false);
  };

  return (
    <li
      className={`nav-item dropdown ${servicesOpen ? "show" : ""}`}
      onMouseEnter={!isMobile ? () => setServicesOpen(true) : undefined}
      onMouseLeave={!isMobile ? closeAllDropdowns : undefined}
    >
      <Link
        to="/services"
        className="nav-link dropdown-toggle"
        role="button"
        onClick={toggleServices}
        aria-expanded={servicesOpen}
        style={{ cursor: "pointer" }}
      >
        {t.services}
      </Link>

      <ul
        className={`dropdown-menu shadow-lg rounded-4 border-0 p-2 ${servicesOpen ? "show" : ""} ${
          language === "ar" ? "dropdown-menu-end text-right" : ""
        }`}
        aria-labelledby="servicesDropdown"
        style={language === "ar" ? { right: "auto", left: 0 } : {}}
      >
        {/* General Contracting */}
        <li
          className={`dropdown-submenu ${generalContractingOpen ? "show" : ""}`}
          onMouseEnter={!isMobile ? () => setGeneralContractingOpen(true) : undefined}
          onMouseLeave={!isMobile ? () => setGeneralContractingOpen(false) : undefined}
          onClick={toggleGeneralContracting}
        >
          <div className="d-flex align-items-center">
            <Link
              to="/general-contracting"
              className="dropdown-item flex-grow-1"
              onClick={handleNavClick}
            >
              {t.generalContracting}
            </Link>
            <span className="ms-2">{language === "ar" ? "‹" : "›"}</span>
          </div>

          <ul
            className={`dropdown-menu rounded-3 border-0 p-2 ${
              generalContractingOpen ? "show" : ""
            } ${language === "ar" ? "dropdown-submenu-rtl" : ""}`}
            style={
              language === "ar"
                ? { right: "100%", left: "auto", marginRight: "0.125rem" }
                : { left: "100%", right: "auto", marginLeft: "0.125rem" }
            }
          >
            {[
              { to: "/residential-projects", label: t.residential },
              { to: "/commercial-projects", label: t.commercial },
              { to: "/infrastructure-projects", label: t.infrastructure },
              { to: "/renovation-finishing", label: t.renovation },
              { to: "/project-supervision", label: t.supervision },
            ].map(({ to, label }) => (
              <li key={to} onClick={handleNavClick}>
                <Link className="dropdown-item" to={to}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </li>

        {/* Equipment Rental */}
        <li
          className={`dropdown-submenu ${equipmentRentalOpen ? "show" : ""}`}
          onMouseEnter={!isMobile ? () => setEquipmentRentalOpen(true) : undefined}
          onMouseLeave={!isMobile ? () => setEquipmentRentalOpen(false) : undefined}
          onClick={toggleEquipmentRental}
        >
          <div className="d-flex align-items-center">
            <Link
              to="/equipment-rental"
              className="dropdown-item flex-grow-1"
              onClick={handleNavClick}
            >
              {t.equipmentRental}
            </Link>
            <span className="ms-2">{language === "ar" ? "‹" : "›"}</span>
          </div>

          <ul
            className={`dropdown-menu rounded-3 border-0 p-2 ${
              equipmentRentalOpen ? "show" : ""
            } ${language === "ar" ? "dropdown-submenu-rtl" : ""}`}
            style={
              language === "ar"
                ? { right: "100%", left: "auto", marginRight: "0.125rem" }
                : { left: "100%", right: "auto", marginLeft: "0.125rem" }
            }
          >
            {[
              { to: "/heavy-equipment", label: t.heavyEquipment },
              { to: "/excavators", label: t.excavators },
              { to: "/cranes-equipment", label: t.cranes },
              { to: "/bulldozers", label: t.bulldozers },
              { to: "/loader-equipment", label: t.loaders },
              { to: "/light-equipment", label: t.lightEquipment },
              { to: "/rental-equipment", label: t.rentalTerms },
              { to: "/operater-equipment", label: t.withOperator },
              { to: "/withoperater-equipment", label: t.withoutOperator },
              { to: "/packages-equipment", label: t.rentalPackages },
            ].map(({ to, label }) => (
              <li key={to} onClick={handleNavClick}>
                <Link className="dropdown-item" to={to}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </li>

        {/* Manpower Supply */}
        <li
          className={`dropdown-submenu ${manpowerSupplyOpen ? "show" : ""}`}
          onMouseEnter={!isMobile ? () => setManpowerSupplyOpen(true) : undefined}
          onMouseLeave={!isMobile ? () => setManpowerSupplyOpen(false) : undefined}
          onClick={toggleManpowerSupply}
        >
          <div className="d-flex align-items-center">
            <Link
              to="/manpower-supply"
              className="dropdown-item flex-grow-1"
              onClick={handleNavClick}
            >
              {t.manpowerSupply}
            </Link>
            <span className="ms-2">{language === "ar" ? "‹" : "›"}</span>
          </div>

          <ul
            className={`dropdown-menu rounded-3 border-0 p-2 ${
              manpowerSupplyOpen ? "show" : ""
            } ${language === "ar" ? "dropdown-submenu-rtl" : ""}`}
            style={
              language === "ar"
                ? { right: "100%", left: "auto", marginRight: "0.125rem" }
                : { left: "100%", right: "auto", marginLeft: "0.125rem" }
            }
          >
            <li className="dropdown-header">{t.skilledLabor}</li>
            {[
              { to: "/elctroinics-equipment", label: t.electricians },
              { to: "/plumber-equipment", label: t.plumbers },
              { to: "/welders-equipment", label: t.welders },
              { to: "/technicians-equipment", label: t.hvacTechnicians },
              { to: "/mechincal-equipment", label: t.mechanicalTechnicians },
              { to: "/civil-equipment", label: t.civilTechnicians },
            ].map(({ to, label }) => (
              <li key={to} onClick={handleNavClick}>
                <Link className="dropdown-item" to={to}>
                  {label}
                </Link>
              </li>
            ))}
            <li className="dropdown-divider"></li>
            <li className="dropdown-header">{t.contractTypes}</li>
            {[
              { to: "/short-equipment", label: t.shortTerm },
              { to: "/long-term", label: t.longTerm },
            ].map(({ to, label }) => (
              <li key={to} onClick={handleNavClick}>
                <Link className="dropdown-item" to={to}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </li>

        {/* Transportation Services */}
        <li
          className={`dropdown-submenu ${transportationServicesOpen ? "show" : ""}`}
          onMouseEnter={!isMobile ? () => setTransportationServicesOpen(true) : undefined}
          onMouseLeave={!isMobile ? () => setTransportationServicesOpen(false) : undefined}
          onClick={toggleTransportationServices}
        >
          <div className="d-flex align-items-center">
            <Link
              to="/transportation-services"
              className="dropdown-item flex-grow-1"
              onClick={handleNavClick}
            >
              {t.transportationServices}
            </Link>
            <span className="ms-2">{language === "ar" ? "‹" : "›"}</span>
          </div>

          <ul
            className={`dropdown-menu rounded-3 border-0 p-2 ${
              transportationServicesOpen ? "show" : ""
            } ${language === "ar" ? "dropdown-submenu-rtl" : ""}`}
            style={
              language === "ar"
                ? { right: "100%", left: "auto", marginRight: "0.125rem" }
                : { left: "100%", right: "auto", marginLeft: "0.125rem" }
            }
          >
            {[
              { to: "/material-transport", label: t.materialTransport },
              { to: "/heavy-equipment-hauling", label: t.heavyEquipmentHauling },
              { to: "/site-to-site-transportation", label: t.siteToSiteTransportation },
              { to: "/project-logistics", label: t.projectLogistics },
              { to: "/custom-transport-solutions", label: t.customTransportSolutions },
            ].map(({ to, label }) => (
              <li key={to} onClick={handleNavClick}>
                <Link className="dropdown-item" to={to}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </li>
  );
};

// Main Header Component
function Header() {
  const { language } = useSelector((state) => state.language);
  const [hoverButton, setHoverButton] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const collapseNavbar = () => {
    const navbarCollapse = document.getElementById("navbarSupportedContent");
    if (navbarCollapse?.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };

  const handleNavClick = () => {
    collapseNavbar();
  };

  const translations = {
    en: {
      home: "Home",
      about: "About Us",
      services: "Services",
      generalContracting: "General Contracting",
      residential: "Residential Projects",
      commercial: "Commercial Projects",
      infrastructure: "Infrastructure Projects",
      renovation: "Renovation & Finishing",
      supervision: "Project Supervision",
      equipmentRental: "Equipment Rental",
      heavyEquipment: "Heavy Equipment",
      excavators: "Excavators",
      cranes: "Cranes",
      bulldozers: "Bulldozers",
      loaders: "Loaders",
      lightEquipment: "Light Equipment",
      rentalTerms: "Rental Terms",
      withOperator: "With Operator",
      withoutOperator: "Without Operator",
      rentalPackages: "Daily/Weekly/Monthly Packages",
      manpowerSupply: "Manpower Supply",
      skilledLabor: "Skilled Labor",
      electricians: "Electricians",
      plumbers: "Plumbers",
      welders: "Welders",
      hvacTechnicians: "HVAC Technicians",
      mechanicalTechnicians: "Mechanical Technicians",
      civilTechnicians: "Civil Technicians",
      contractTypes: "Contract Types",
      shortTerm: "Short-term",
      longTerm: "Long-term",
      transportationServices: "Transportation Services",
      materialTransport: "Material Transport",
      heavyEquipmentHauling: "Heavy Equipment Hauling",
      siteToSiteTransportation: "Site-to-site Transportation",
      projectLogistics: "Project Logistics",
      customTransportSolutions: "Custom Transport Solutions",
      projects: "Projects",
      careers: "Careers",
      blog: "Blog",
      contact: "Contact",
      getQuote: "Get a Quote",
    },
    sa: {
      home: "الرئيسية",
      about: "من نحن",
      services: "الخدمات",
      generalContracting: "المقاولات العامة",
      residential: "المشاريع السكنية",
      commercial: "المشاريع التجارية",
      infrastructure: "مشاريع البنية التحتية",
      renovation: "التجديد والتشطيب",
      supervision: "إشراف المشروع",
      equipmentRental: "تأجير المعدات",
      heavyEquipment: "المعدات الثقيلة",
      excavators: "حفارات",
      cranes: "رافعات",
      bulldozers: "جرافات",
      loaders: "لوادر",
      lightEquipment: "المعدات الخفيفة",
      rentalTerms: "شروط التأجير",
      withOperator: "مع مشغل",
      withoutOperator: "بدون مشغل",
      rentalPackages: "باقات يومية/أسبوعية/شهرية",
      manpowerSupply: "توفير القوى العاملة",
      skilledLabor: "عمالة ماهرة",
      electricians: "كهربائيون",
      plumbers: "سباكون",
      welders: "لحامون",
      hvacTechnicians: "فنيو تكييف",
      mechanicalTechnicians: "فنيو ميكانيكا",
      civilTechnicians: "فنيو مدني",
      contractTypes: "أنواع العقود",
      shortTerm: "قصير الأجل",
      longTerm: "طويل الأجل",
      transportationServices: "خدمات النقل",
      materialTransport: "نقل المواد",
      heavyEquipmentHauling: "نقل المعدات الثقيلة",
      siteToSiteTransportation: "النقل من موقع إلى موقع",
      projectLogistics: "لوجستيات المشروع",
      customTransportSolutions: "حلول النقل المخصصة",
      projects: "المشاريع",
      careers: "الوظائف",
      blog: "المدونة",
      contact: "اتصل بنا",
      getQuote: "احصل على عرض سعر",
    },
    fr: {
      home: "Accueil",
      about: "À propos de nous",
      services: "Services",
      generalContracting: "Entreprise générale",
      residential: "Projets résidentiels",
      commercial: "Projets commerciaux",
      infrastructure: "Projets d'infrastructure",
      renovation: "Rénovation & Finition",
      supervision: "Supervision de projet",
      equipmentRental: "Location d'équipement",
      heavyEquipment: "Équipement lourd",
      excavators: "Pelles excavatrices",
      cranes: "Grues",
      bulldozers: "Bulldozers",
      loaders: "Chargeuses",
      lightEquipment: "Équipement léger",
      rentalTerms: "Conditions de location",
      withOperator: "Avec opérateur",
      withoutOperator: "Sans opérateur",
      rentalPackages: "Forfaits quotidiens/hebdomadaires/mensuels",
      manpowerSupply: "Fourniture de main-d'œuvre",
      skilledLabor: "Main-d'œuvre qualifiée",
      electricians: "Électriciens",
      plumbers: "Plombiers",
      welders: "Soudeurs",
      hvacTechnicians: "Techniciens CVC",
      mechanicalTechnicians: "Techniciens en mécanique",
      civilTechnicians: "Techniciens en génie civil",
      contractTypes: "Types de contrats",
      shortTerm: "À court terme",
      longTerm: "À long terme",
      transportationServices: "Services de transport",
      materialTransport: "Transport de matériaux",
      heavyEquipmentHauling: "Transport d'équipement lourd",
      siteToSiteTransportation: "Transport de site à site",
      projectLogistics: "Logistique de projet",
      customTransportSolutions: "Solutions de transport personnalisées",
      projects: "Projets",
      careers: "Carrières",
      blog: "Blog",
      contact: "Contact",
      getQuote: "Obtenir un devis",
    },
    de: {
      home: "Startseite",
      about: "Über uns",
      services: "Dienstleistungen",
      generalContracting: "Generalunternehmer",
      residential: "Wohnprojekte",
      commercial: "Gewerbliche Projekte",
      infrastructure: "Infrastrukturprojekte",
      renovation: "Renovierung & Fertigstellung",
      supervision: "Projektüberwachung",
      equipmentRental: "Gerätevermietung",
      heavyEquipment: "Schwere Ausrüstung",
      excavators: "Bagger",
      cranes: "Kräne",
      bulldozers: "Bulldozer",
      loaders: "Lader",
      lightEquipment: "Leichte Ausrüstung",
      rentalTerms: "Vermietungsbedingungen",
      withOperator: "Mit Bediener",
      withoutOperator: "Ohne Bediener",
      rentalPackages: "Tages-/Wochen-/Monatspakete",
      manpowerSupply: "Arbeitskräfteversorgung",
      skilledLabor: "Facharbeiter",
      electricians: "Elektriker",
      plumbers: "Klempner",
      welders: "Schweißer",
      hvacTechnicians: "HLK-Techniker",
      mechanicalTechnicians: "Mechaniker",
      civilTechnicians: "Bauingenieure",
      contractTypes: "Vertragsarten",
      shortTerm: "Kurzfristig",
      longTerm: "Langfristig",
      transportationServices: "Transportdienstleistungen",
      materialTransport: "Materialtransport",
      heavyEquipmentHauling: "Schwergerätetransport",
      siteToSiteTransportation: "Standort-zu-Standort-Transport",
      projectLogistics: "Projektlogistik",
      customTransportSolutions: "Maßgeschneiderte Transportlösungen",
      projects: "Projekte",
      careers: "Karriere",
      blog: "Blog",
      contact: "Kontakt",
      getQuote: "Angebot einholen",
    }
  };

  const t = translations[language] || translations.en;

  const handleQat = () => {
    navigate("/GetAQat");
    handleNavClick();
  };

  return (
    <header dir={language === "ar" ? "rtl" : "ltr"}>
      <nav className="navbar navbar-expand-lg bg-white shadow-sm">
        <div className="container">
          <Link
            to="/home"
            className="navbar-brand d-flex align-items-center"
            onClick={handleNavClick}
          >
            <img
              src={logo}
              alt="Company Logo"
              style={{ height: "40px", objectFit: "contain" }}
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div
            className={`collapse navbar-collapse justify-content-between ${
              language === "ar" ? "rtl-nav" : ""
            }`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 d-flex gap-lg-4 text-center align-items-lg-center">
              <li className="nav-item" onClick={handleNavClick}>
                <Link className="nav-link" to="/home">
                  {t.home}
                </Link>
              </li>
              <li className="nav-item" onClick={handleNavClick}>
                <Link className="nav-link" to="/about">
                  {t.about}
                </Link>
              </li>

              <NavDropdown
                t={t}
                language={language}
                isMobile={isMobile}
                handleNavClick={handleNavClick}
              />

              <li className="nav-item" onClick={handleNavClick}>
                <Link className="nav-link" to="/project">
                  {t.projects}
                </Link>
              </li>
              <li className="nav-item" onClick={handleNavClick}>
                <Link className="nav-link" to="/careers">
                  {t.careers}
                </Link>
              </li>
              <li className="nav-item" onClick={handleNavClick}>
                <Link className="nav-link" to="/blog">
                  {t.blog}
                </Link>
              </li>
              <li className="nav-item" onClick={handleNavClick}>
                <Link className="nav-link" to="/contact">
                  {t.contact}
                </Link>
              </li>
            </ul>

            <div className="mt-3 mt-lg-0 d-flex justify-content-center justify-content-lg-end">
              <button
                className={`btn d-flex align-items-center transition-all ${
                  hoverButton ? "btn-dark" : "btn-danger"
                }`}
                onMouseEnter={() => setHoverButton(true)}
                onMouseLeave={() => setHoverButton(false)}
                style={{
                  borderRadius: "50px",
                  gap: "0.5rem",
                  padding: "0.5rem 1.2rem",
                  flexDirection: language === "ar" ? "row-reverse" : "row",
                }}
                onClick={handleQat}
              >
                {t.getQuote}
                <img
                  src={Arrow}
                  alt="Arrow Icon"
                  style={{
                    height: "26px",
                    transition: "transform 0.3s",
                    transform: hoverButton
                      ? `translateX(${language === "ar" ? "-5px" : "5px"})`
                      : "none",
                  }}
                />
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;